import React from 'react';
import { Clock, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
interface EventCardProps {
  title: string;
  date?: string;
  time: string;
  location: string;
  image: string;
  day: string;
  month: string;
  eventType?: 'in-person' | 'online';
}
export function EventCard({
  title,
  date,
  time,
  location,
  image,
  day,
  month,
  eventType = 'in-person'
}: EventCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} whileHover={{
    y: -4
  }} transition={{
    duration: 0.3
  }} className="bg-white rounded-lg overflow-visible shadow-sm hover:shadow-lg transition-shadow relative pt-6" data-id="element-211">
      {/* Ribbon Date Badge */}
      <div className="absolute -top-0 left-4 z-10" data-id="element-212">
        <div className="bg-[#0A1F44] text-white text-center px-3 pt-2 pb-3 rounded-b-md relative" data-id="element-213">
          <span className="block text-[10px] font-semibold uppercase tracking-wider" data-id="element-214">
            {month}
          </span>
          <span className="block text-2xl font-bold leading-none" data-id="element-215">{day}</span>
          {/* Ribbon tail */}
          <div className="absolute -bottom-2 left-0 right-0 flex justify-center" data-id="element-216">
            <div className="w-0 h-0 border-l-[24px] border-r-[24px] border-t-[8px] border-l-transparent border-r-transparent border-t-[#0A1F44]" data-id="element-217" />
          </div>
        </div>
      </div>

      {/* Event Type Badge */}
      <div className="absolute top-2 right-4 z-10" data-id="element-218">
        <span className={`text-[10px] font-semibold uppercase tracking-wider px-3 py-1 rounded-full border ${eventType === 'online' ? 'bg-white text-[#0A1F44] border-[#0A1F44]' : 'bg-white text-gray-700 border-gray-300'}`} data-id="element-219">
          {eventType === 'online' ? 'Online' : 'In Person'}
        </span>
      </div>

      {/* Image */}
      <div className="px-4 pt-8 pb-4" data-id="element-220">
        <div className="aspect-[4/3] rounded-lg overflow-hidden" data-id="element-221">
          <img src={image} alt={title} className="w-full h-full object-cover" data-id="element-222" />
        </div>
      </div>

      {/* Content */}
      <div className="px-4 pb-5" data-id="element-223">
        <h3 className="text-lg font-bold text-[#0A1F44] mb-3 leading-tight hover:text-[#0A1F44] transition-colors cursor-pointer line-clamp-2" data-id="element-224">
          {title}
        </h3>

        <div className="space-y-1.5 text-sm text-[#0A1F44]" data-id="element-225">
          <div className="flex items-center gap-2" data-id="element-226">
            <Clock className="w-4 h-4 text-gray-400" data-id="element-227" />
            <span data-id="element-228">{time}</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-229">
            <MapPin className="w-4 h-4 text-gray-400" data-id="element-230" />
            <span data-id="element-231">{location}</span>
          </div>
        </div>
      </div>
    </motion.div>;
}